import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { jobsApi } from '../services/api';
import { AlertTriangle, ArrowLeft, Loader2 } from 'lucide-react';
import './UrlErrorTracebackPage.css';

const UrlErrorTracebackPage: React.FC = () => {
  const { jobId, urlId } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      if (!jobId || !urlId) {
        setError('Invalid parameters');
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const res = await jobsApi.getUrlErrorTraceback(jobId, urlId);
        setData(res);
      } catch (e: any) {
        const status = e?.status;
        if (status === 401 || status === 403) {
          setError('権限がありません。ログイン状態を確認してください。');
        } else if (status === 404) {
          setError('このURLのトレースバックは存在しません（404/403エラーの場合は保存されません）。');
        } else {
          setError(e?.message || 'Failed to load traceback');
        }
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [jobId, urlId]);

  return (
    <div className="url-error-traceback-page">
      <div className="traceback-header">
        <Link to="/results" className="back-link">
          <ArrowLeft size={16} />
          一覧に戻る
        </Link>
        <h2 className="traceback-title">エラー詳細</h2>
      </div>

      {loading && (
        <div className="traceback-loading">
          <Loader2 size={20} className="animate-spin" />
          <span>読み込み中...</span>
        </div>
      )}

      {!loading && error && (
        <div className="traceback-error">
          <AlertTriangle size={18} />
          <div>
            <div className="traceback-error-title">取得に失敗しました</div>
            <div className="traceback-error-message">{error}</div>
          </div>
        </div>
      )}

      {!loading && !error && (
        <div className="traceback-card">
          <div className="traceback-meta">
            <div className="meta-row">
              <span className="meta-label">URL</span>
              <span className="meta-value">{data?.url || '—'}</span>
            </div>
            <div className="meta-row">
              <span className="meta-label">ステータスコード</span>
              <span className="meta-value">{data?.status_code ?? '—'}</span>
            </div>
            <div className="meta-row">
              <span className="meta-label">メッセージ</span>
              <span className="meta-value">{data?.error_message_user || 'システムでエラーが発生しました'}</span>
            </div>
          </div>

          <div className="traceback-section">
            <div className="traceback-section-title">Traceback</div>
            <pre className="traceback-pre">
              {data?.traceback || 'Traceback not available'}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default UrlErrorTracebackPage;

